var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon27(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.56627 26.6666C9.7496 25.8499 9.41627 24.6833 8.83294 24.0999L4.78294 20.0499C3.51627 18.7832 3.01627 17.4333 3.38294 16.2666C3.76627 15.0999 4.9496 14.2999 6.71627 13.9999L11.9163 13.1333C12.6663 12.9999 13.5829 12.3333 13.9329 11.6499L16.7996 5.89992C17.6329 4.24992 18.7663 3.33325 19.9996 3.33325C21.2329 3.33325 22.3663 4.24992 23.1996 5.89992L26.0663 11.6499C26.2829 12.0833 26.7329 12.4999 27.2163 12.7833L9.26627 30.7332C9.03294 30.9666 8.63294 30.7499 8.6996 30.4166L9.56627 26.6666Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.168 24.0999C30.568 24.6999 30.2346 25.8499 30.4346 26.6666L31.5846 31.6832C32.068 33.7666 31.768 35.3332 30.7346 36.0832C30.318 36.3832 29.818 36.5332 29.2346 36.5332C28.3846 36.5332 27.3846 36.2166 26.2846 35.5666L21.4013 32.6666C20.6346 32.2166 19.368 32.2166 18.6013 32.6666L13.718 35.5666C11.868 36.6499 10.2846 36.8332 9.26797 36.0832C8.88463 35.7999 8.6013 35.4166 8.41797 34.9166L28.6846 14.6499C29.4513 13.8832 30.5346 13.5332 31.5846 13.7166L33.268 13.9999C35.0346 14.2999 36.218 15.0999 36.6013 16.2666C36.968 17.4332 36.468 18.7832 35.2013 20.0499L31.168 24.0999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon27);
export default __webpack_public_path__ + "static/media/icon-27.51482712c5436387ce5028224950ed59.svg";
export { ForwardRef as ReactComponent };